<template>
  <v-card
    class="filtros"
    outlined
    :loading="loading"
    @click="$emit('select', counter.eventValue)"
  >
    <v-card-text class="d-flex align-center justify-space-between pa-2">
      <v-avatar class="v-avatar-light-bg primary--text">
        <v-icon
          size="25"
          class="rounded-0"
          :color="counter.icon.color"
        >
          {{ counter.icon.shape }}
        </v-icon>
      </v-avatar>

      <div class="d-flex align-center ml-2">
        <h2 class="font-weight-semibold mr-2">
          {{ counter.quantity }}
        </h2>

        <span>{{ counter.title }}</span>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  emits: ['select'],

  props: {
    loading: Boolean,
    counter: {
      type: Object,
      required: true,
    },
  },
}
</script>
